import React from "react";
import { Table, Space, Divider, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import { permissionsFilter } from "../../../utils/permissionsFilter";
import ApiConstants from "../../../api/ApiConstants";
import Eye from "../../../public/images/dashboard/tables/eye.svg";
import Delete from "../../../public/images/dashboard/tables/delete.svg";
import "../../../public/sass/layout/_index.scss";

const RequestsTable = ({
  requests,
  loading,
  getRequestById,
  deleteRequest,
}) => {
  const { t, i18n } = useTranslation();

  const handleStatus = (status) => {
    switch (status) {
      case 0:
        return {
          color: "#13c2c2",
          item: t("status_accepted"),
        };
      case 1:
        return {
          color: "#cf1322",
          item: t("status_not_accepted"),
        };
      case 2:
        return {
          color: "#1890ff",
          item: t("status_in_progress"),
        };
      case 3:
        return {
          color: "#389e0d",
          item: t("status_done"),
        };
      case 4:
        return {
          color: "#820014",
          item: t("status_not_active"),
        };
      default:
        return {
          color: "#820014",
          item: t("status_not_active"),
        };
    }
  };

  const columns = [
    {
      title: "Nr",
      dataIndex: "request_id",
      key: "request_id",
    },
    {
      title: "Vorname",
      dataIndex: "owner_firstname",
      key: "owner_firstname",
    },
    {
      title: "Nachname",
      dataIndex: "owner_lastname",
      key: "owner_lastname",
    },
    {
      title: "Addresse",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Mail",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <>
          <a style={{ color: `${handleStatus(status).color}` }}>
            {handleStatus(status).item}
          </a>
        </>
      ),
    },
    {
      title: "Aktion",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e) => (
        <Space size="middle">
          {permissionsFilter('Open Requests', 'OpenRequestUpdate') &&
            <a onClick={() => getRequestById(e?.id)}>
              <img src={Eye} alt="Edit" />
            </a>
          }
          {permissionsFilter('Open Requests', 'OpenRequestDelete') &&
            <Popconfirm
              title={t("are_you_sure")}
              onConfirm={() => deleteRequest(e?.id)}
            >
              <a>
                <img src={Delete} alt="Delete" />
              </a>
            </Popconfirm>
          }
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Divider />
      <Table
        loading={loading}
        columns={columns}
        dataSource={requests}
        className="table"
        scroll={{ y: ApiConstants.TABLE_HEIGHT }}
      />
    </div>
  );
};
export default RequestsTable;
